import Component from "./InputNumberListWithTag";
export default Component;
